import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { CollapsableRowComponent } from './collapsable-row/collapsable-row.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalInfoComponent } from './modal-info/modal-info.component';
import { ModalActionableComponent } from './modal-actionable/modal-actionable.component';
import { ApcActionCardComponent } from './apc-action-card/apc-action-card.component';
import { DatatableComponent } from './datatable/datatable.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SwitchComponent } from './form/switch/switch.component';
import { AllActionsComponent } from './apc-action-card/buttons/multi-actions/multi-actions.component';
import { SemiActionsComponent } from './apc-action-card/buttons/mono-actions/mono-actions.component';
import { SaveBackActionsComponent } from './apc-action-card/buttons/save-back-actions/save-back-actions.component';
import { NavbarBigComponent } from './navbars/navbar-big/navbar-big.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NavbarSmallComponent } from './navbars/navbar-small/navbar-small.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CreateElementButtonsComponent } from './create-element-buttons/create-element-buttons.component';
import { AdminCrudButtonsComponent } from './apc-action-card/buttons/admin-crud-buttons/admin-crud-buttons.component';
import { LoadingComponent } from './loading/loading.component';
import { isEllipsisActiveDirective } from './directives/isEllipsisActiveDirective.directive';
import { TrapFocusDirective } from './directives/trap-focus.directive';
import { CheckPermissionDirective } from './directives/permissions.directive';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { InputComponent } from './form/input/input.component';
import { ApcSectionAnchorsComponent } from './apc-section-anchors/apc-section-anchors.component';
import { BasicCrudModalComponent } from './basic-crud-modal/basic-crud-modal.component';
import { OfficeDropdownFormComponent } from './basic-crud-modal/admin/office-form/office-form.component';
import { ExtrasFormComponent } from './basic-crud-modal/admin/extras-form/extras-form.component';
import { ExtraFieldsButtonsComponent } from './apc-action-card/buttons/extra-fields-buttons/extra-fields-buttons.component';
import { NoteFormComponent } from './basic-crud-modal/extra-fields/note/note.component';
import { CodeValueFormComponent } from './basic-crud-modal/admin/code-value-form/code-value-form.component';
import { FileComponent } from './basic-crud-modal/extra-fields/file/file.component';
import { LinkComponent } from './basic-crud-modal/extra-fields/link/link.component';
import { CustomFieldComponent } from './basic-crud-modal/extra-fields/custom-field/custom-field.component';
import { MultiFormsComponent } from './multi-forms/multi-forms.component';
import { AdminOPerationsSolutionComponent } from './basic-crud-modal/admin/solution/solution.component';
import { AdminSectionManagementCertificationTypeComponent } from './basic-crud-modal/admin/certification-type/certification-type.component';
import { AccountTypeComponent } from './basic-crud-modal/admin/account-type/account-type.component';
import { IdentificationTypeComponent } from './basic-crud-modal/admin/identification-type/identification-type.component';
import { SelectComponent } from './form/select/select.component';
import { HelpIconComponent } from './form/help-icon/help-icon.component';
import { FiltersComponent } from './datatable/filters/filters.component';
import { ComputerComponent } from './basic-crud-modal/admin/equipment/computer/computer.component';
import { CompanycarComponent } from './basic-crud-modal/admin/equipment/companycar/companycar.component';
import { FuelcardComponent } from './basic-crud-modal/admin/equipment/fuelcard/fuelcard.component';
import { SimcardComponent } from './basic-crud-modal/admin/equipment/simcard/simcard.component';
import { TelepassComponent } from './basic-crud-modal/admin/equipment/telepass/telepass.component';
import { HighLightPipe } from './directives/highlightPipe.directive';
import { ReportsDatasetComponent } from './reports-dataset/reports-dataset.component';
import { TagInputModule } from 'ngx-chips';
import { ReportFiltersComponent } from './reports-dataset/filters/filters.component';
import { SheetExportComponent } from './reports-dataset/filters/sheet-export/sheet-export.component';
import { GameggComponent } from './gamegg/gamegg.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { NgxCurrencyDirective } from 'ngx-currency';


@NgModule({
  declarations: [
    CollapsableRowComponent,
    DatatableComponent,
    ModalInfoComponent,
    ModalActionableComponent,
    ApcActionCardComponent,
    SwitchComponent,
    AllActionsComponent,
    SemiActionsComponent,
    SaveBackActionsComponent,
    NavbarBigComponent,
    NavbarSmallComponent,
    CreateElementButtonsComponent,
    AdminCrudButtonsComponent,
    LoadingComponent,
    isEllipsisActiveDirective,
    TrapFocusDirective,
    CheckPermissionDirective,
    InputComponent,
    ApcSectionAnchorsComponent,
    BasicCrudModalComponent,
    OfficeDropdownFormComponent,
    ExtrasFormComponent,
    ExtraFieldsButtonsComponent,
    NoteFormComponent,
    CodeValueFormComponent,
    FileComponent,
    LinkComponent,
    CustomFieldComponent,
    MultiFormsComponent,
    AdminOPerationsSolutionComponent,
    AdminSectionManagementCertificationTypeComponent,
    AccountTypeComponent,
    IdentificationTypeComponent,
    SelectComponent,
    HelpIconComponent,
    FiltersComponent,
    ComputerComponent,
    CompanycarComponent,
    FuelcardComponent,
    SimcardComponent,
    TelepassComponent,
    HighLightPipe,
    ReportsDatasetComponent,
    ReportFiltersComponent,
    SheetExportComponent,
    GameggComponent,
    SearchBarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgClickOutsideDirective,
    NgbModule,
    NgxDatatableModule,
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    NgSelectModule,
    TagInputModule,
    NgxCurrencyDirective
    ],
  exports: [
    CollapsableRowComponent,
    DatatableComponent,
    ModalInfoComponent,
    ModalActionableComponent,
    ApcActionCardComponent,
    InlineSVGModule,
    SwitchComponent,
    AllActionsComponent,
    SemiActionsComponent,
    SaveBackActionsComponent,
    NavbarBigComponent,
    NavbarSmallComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    CreateElementButtonsComponent,
    AdminCrudButtonsComponent,
    LoadingComponent,
    isEllipsisActiveDirective,
    TrapFocusDirective,
    CheckPermissionDirective,
    InputComponent,
    ApcSectionAnchorsComponent,
    BasicCrudModalComponent,
    MultiFormsComponent,
    SelectComponent,
    HelpIconComponent,
    HighLightPipe,
    ReportsDatasetComponent,
    TagInputModule,
    ReportFiltersComponent,
    GameggComponent,
    SearchBarComponent,
    FiltersComponent,
    NgxCurrencyDirective 
    ],
  providers: [DatePipe, CurrencyPipe],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class UiModule {}
